<div mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="header">
  <span>
    <fa-icon size="2xl" style="padding: 10px" [icon]="sceneTemplate.mimeType | PipeIcon"></fa-icon>
    <mat-label>{{ sceneTemplate.mimeType }}</mat-label>
  </span>
    <div class="dlg-drag-handle" cdkDragHandle>
        <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
            <path
                    d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
            </path>
            <path d="M0 0h24v24H0z" fill="none"></path>
        </svg>
    </div>
</div>
<div mat-dialog-content>
    <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="16px">
        <mat-form-field class="example-form-field" style="width: 180px;">
            <mat-label>{{ 'general.name' | transloco }}</mat-label>
            <input [disableControl]="{mode: true, timeoutToEnable: 200}" inputrestriction="basic1" matInput type="text" name="new-scene" placeholder=""
                   [(ngModel)]="sceneTemplate.sceneTitle" autocomplete="off">
        </mat-form-field>
        <!--            <mat-form-field class="example-form-field" style="width: 120px;">-->
        <!--                <mat-label>{{'general.width' | transloco}}</mat-label>-->
        <!--                <input inputrestriction="basic1" matInput type="number" max="4096" placeholder=""-->
        <!--                    [(ngModel)]="sceneTemplate.width">-->
        <!--            </mat-form-field>-->
        <!--            <mat-form-field class="example-form-field" style="width: 120px;">-->
        <!--                <mat-label>{{'general.height' | transloco}}</mat-label>-->
        <!--                <input inputrestriction="basic1" matInput type="number" max="4096" placeholder=""-->
        <!--                    [(ngModel)]="sceneTemplate.height">-->
        <!--            </mat-form-field>-->
    </div>

    <div class="image-wrapper">
        @if (sceneTemplate.folder !== 'Presentation') {
            <div>
                <img class="import-img" (load)="onLoad()" src="{{sceneTemplate.url}}"/>
            </div>
        }

        @if (sceneTemplate.folder === 'Presentation') {
            <div>
                <ngx-flicking #flicking0 [options]="{ bounce: 30 }" [plugins]="thumbPlugins">
                    @for (thumbUrl of sceneTemplate.thumbs; track thumbUrl) {
                        <div flicking-panel class="flicking-panel full">
                            <img class="panel-image" (load)="onLoad()" src="{{thumbUrl}}"/>
                        </div>
                    }
                </ngx-flicking>
                <ngx-flicking #flicking1 [options]="{ bound: true, bounce: 30, moveType: 'freeScroll' }">
                    @for (thumbUrl of sceneTemplate.thumbs; track thumbUrl) {
                        <div flicking-panel class="flicking-panel thumb">
                            <img class="thumb-image" src="{{thumbUrl}}"/>
                        </div>
                    }
                </ngx-flicking>
            </div>
        }

        @if (imageLoading) {
            <div class="image-loading">
                <app-loading [type]="-1" [size]="'60px'"></app-loading>
            </div>
        }
    </div>

    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="32px" style="margin-top: 20px;">
        @if (!imageLoading) {
            <button mat-raised-button color="warn" (click)="onClickImport(sceneTemplate)" style="min-width: 120px;">
                <mat-icon>downloading</mat-icon>
                {{ 'general.import' | transloco }}
            </button>
        }
        <button mat-raised-button color="primary" (click)="closeModal()"
                style="min-width: 120px;">
            {{ 'general.cancel' | transloco }}
        </button>
    </div>
</div>
